import type { IOpportunityMSServiceNote } from './../types/note/models'
import { makeNoteService } from '~/cynqueModules/factoriesForServices/notes'

export const {
  createNote: createOpportunityMSServiceNote,
  updateNote: updateOpportunityMSServiceNote,
  deleteNote: deleteOpportunityMSServiceNote,
} = makeNoteService<IOpportunityMSServiceNote>(
  '/api/opportunitymsservicenotes',
  'opportunityMSServiceNote'
)
